import { create } from 'zustand';
import { safeStorage } from './storage';

/**
 * Плотность реестров (README «Настраиваемые параметры»: comfortable — строки 38, compact — 32;
 * «Плотность стоит оставить пользовательской настройкой»). Сохраняется в safe storage.
 */
export const TABLE_DENSITIES = ['comfortable', 'compact'] as const;
export type TableDensity = (typeof TABLE_DENSITIES)[number];

const STORAGE_KEY = 'ui.table_density';

function isTableDensity(value: unknown): value is TableDensity {
  return TABLE_DENSITIES.some((density) => density === value);
}

function readDensity(): TableDensity {
  const stored = safeStorage.get(STORAGE_KEY);
  return isTableDensity(stored) ? stored : 'comfortable';
}

interface TableDensityState {
  density: TableDensity;
  setDensity: (density: TableDensity) => void;
}

export const useTableDensity = create<TableDensityState>()((set) => ({
  density: readDensity(),
  setDensity: (density) => {
    safeStorage.set(STORAGE_KEY, density);
    set({ density });
  },
}));

export { isTableDensity };
